<template>
  <TeamMembersPanel
    v-model:selected-users="selected_users"
    v-model:deselected-users="deselected_users"
    :count="count"
    :excluded-records="excludedRecords"
    :is-all-records="isAllRecords"
    @submit="submitCoOwners"
    @cancel="$emit('cancel')" />
</template>

<script>
import dataService from "@/services/data.service"
import TeamMembersPanel from "../shared/TeamMembersPanel.vue"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    TeamMembersPanel
  },
  props: {
    filter: null,
    records: {
      type: Array,
      required: false
    },
    fullRecords: {
      type: Array,
      required: false
    },
    record: {
      type: Object,
      required: false
    },
    objectType: {
      type: String,
      required: false
    },
    excludedRecords: {
      type: Array,
      default: () => []
    },
    isAllRecords: {
      type: Boolean,
      default: false
    },
    count: null
  },
  emits: ["cancel", "submitted", "done"],
  data() {
    return {
      selected_users: [],
      deselected_users: []
    }
  },

  created() {
    if (this.isAllRecords) {
      this.selected_users = []
    } else if (this.fullRecords?.length) {
      let all_selected = []
      this.fullRecords.forEach((r) => all_selected.push(...r.co_owners))
      this.selected_users = Array.from(new Set(all_selected))
    } else if (this.records?.length) {
      let all_selected = []
      this.fullRecords.forEach((r) => all_selected.push(...r.co_owners))
      this.selected_users = Array.from(new Set(all_selected))
    } else {
      this.selected_users = this.record.co_owners
    }
  },

  methods: {
    submitCoOwners(co_owners) {
      let ids = null
      if (this.records?.length) {
        ids = this.records
        let data = {
          assigned_co_owners: this.selected_users.map((u) => u.id),
          unassigned_co_owners: this.deselected_users.map((u) => u.id),
          records: ids
        }

        dataService.assignCompaniesCoOwners(data).then(() => {
          this.$emit("done")
        })
        this.fullRecords.map((r) => {
          r.co_owners = this.selected_users.map((u) => u.id)
          this.$store.dispatch("data/emitRecordUpdatedEmitters", r)
        })
      } else if (this.record) {
        {
          let new_record = { ...this.record }

          new_record.co_owners = co_owners.map((u) => u.id)

          this.$store.dispatch("ui/setCurrentCompany", new_record)

          let data = { co_owners: co_owners.map((u) => u.id) }

          this.$store.dispatch("data/updateRecord", { record_id: this.record.id, data: data }).then((res) => {
            this.$emit("done")
            this.$store.dispatch("data/emitRecordUpdatedEmitters", res.data)
          })
        }
      } else if (this.isAllRecords) {
        ids = []
        let data = {
          filter: this.filter,
          assigned_co_owners: this.selected_users.map((u) => u.id),
          unassigned_co_owners: this.deselected_users.map((u) => u.id),
          records: ids,
          is_all_records: this.isAllRecords,
          object_type: this.objectType,
          excluded_records: this.excludedRecords
        }

        dataService.assignCompaniesCoOwners(data).then(() => {
          this.$emit("done")
          this.$emitter.emit(ALL_EMITTERS.REFRESH_TABLE)
        })
      }
    }
  }
}
</script>
